















































































import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import HighLightText from '@/components/atoms/HighLightText.vue';
import PanelActionButton, {
  PanelActionButtonItemType,
} from '@/components/atoms/PanelActionButton.vue';
import { getUrlTarget } from '@/containers/globals/Util';
import { ID, ProductMenu } from '@/types/type';
import { REL } from '@/utils/consts';

@Component({
  components: { PanelActionButton, HighLightText },
})
export default class SearchResultItem extends Vue {
  @Prop()
  private useFavorite!: boolean;

  @Prop()
  private item!: ProductMenu;

  @Prop()
  private matchedText!: string;

  @Prop()
  private language!: string;

  @Prop()
  private disableMessage!: string;

  private hoverOnMenu: boolean = false;
  private hoverOnDisabled: boolean = false;

  @Emit('click')
  private clickItem(menu: ProductMenu): ProductMenu {
    return menu;
  }

  private updateFavorite(menu: ProductMenu): void {
    menu.isFavorite ? this.remveFavorite(menu.id) : this.addFavorite(menu);
  }

  @Emit('add-favorite')
  private addFavorite(menu: ProductMenu): ProductMenu {
    return menu;
  }

  @Emit('remove-favorite')
  private remveFavorite(id: ID): ID {
    return id;
  }
}
